module.exports = __webpack_public_path__ + "static/media/particle-left.6c816238.png";